import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MdOutlineDashboard, MdOutlineCancel } from 'react-icons/md';
import {  FaUser } from 'react-icons/fa';
import { TbCalendarStats } from "react-icons/tb";
import { useStateContext } from '../Context/ContextProvider';
import 'tw-elements';

const SideBar = () => {
  const { activeMenu, setActiveMenu } = useStateContext();

  const sidebarRef = useRef(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Update screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Close sidebar when clicking outside of it on mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setActiveMenu(false);
      }
    };

    if (isMobile && activeMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [activeMenu, isMobile, setActiveMenu]);

  // user details
  const currentUser = window.localStorage.getItem('token');
  const user = JSON.parse(currentUser).data.user_data;


  return (
    <main className='bg-[#1F2937] text-white h-screen md:overflow-hidden relative overflow-auto md:hover:overflow-auto pb-10'>
      {activeMenu && (
        <>
          <div className='flex justify-between items-center relative p-4 font-sans font-bold border-b border-b-[#7987a1]'>
            <h3>Reports</h3>
            <div className='text-xl rounded-full hover:bg-light-gray block md:hidden'>
              <button onClick={() => setActiveMenu(!activeMenu)}><MdOutlineCancel /></button>
            </div>
          </div>
          <div className='flex items-center justify-evenly p-4'>
            <div>
              <div className='bg-[#BDBDBD] h-20 w-20  rounded-full text-2xl flex items-center justify-center'><span>{user.first_name[0]}</span></div>
            </div>
            <div className='space-y-0.5'>
              <p><b>{user.first_name} {user.last_name}</b></p>
              <p><b>{user.role}</b></p>
            </div>
          </div>
          <nav>
            <div className='overflow-y-auto'>
              <div id='sidenavSecExample'>
                <ul className='relative px-1'>
                  <li className='relative'>
                    <Link to='/' className='flex items-center text-md py-4 px-6 h-12 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#2b1e3e] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>
                      <span className='w-4 h-4 mr-3'><MdOutlineDashboard /></span>
                      <span>DashBoard</span>
                    </Link>
                  </li>
                  {user.role === 'ADMIN' && (
                    <li className='relative' id='sidenavXxEx1'>
                      <span className='flex items-center text-md py-4 px-6 h-12 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#2b1e3e] hover:bg-blue-50 transition duration-300 ease-in-out cursor-pointer' data-mdb-ripple='true' data-mdb-ripple-color='primary' data-bs-toggle='collapse' data-bs-target='#collapseSidenavXxEx1' aria-expanded='false' aria-controls='collapseSidenavXxEx1'>
                        <span className='w-4 h-4 mr-3'><FaUser /></span>
                        <span>Admins</span>
                        <svg aria-hidden='true' focusable='false' data-prefix='fas' className='w-3 h-3 ml-auto' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'>
                          <path fill='currentColor' d='M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z' />
                        </svg>
                      </span>
                      <ul className='relative accordion-collapse collapse' id='collapseSidenavXxEx1' aria-labelledby='sidenavXxEx1' data-bs-parent='#sidenavSecExample'>
                        <li className='relative'>
                          <Link to='/admins' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#2b1e3e] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Admins</Link>
                        </li>
                        
                          <li className='relative'>
                            <Link to='/addadmin' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#2b1e3e] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Add Admin</Link>
                          </li>
                        
                      </ul>
                    </li>
                  )}
                  <li className='relative' id='sidenavXxEx2'>
                    <span className='flex items-center text-md py-4 px-6 h-12 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#2b1e3e] hover:bg-blue-50 transition duration-300 ease-in-out cursor-pointer' data-mdb-ripple='true' data-mdb-ripple-color='primary' data-bs-toggle='collapse' data-bs-target='#collapseSidenavXxEx2' aria-expanded='false' aria-controls='collapseSidenavXxEx2'>
                      <span className='w-4 h-4 mr-3'><TbCalendarStats /></span>
                      <span>Reports</span>
                      <svg aria-hidden='true' focusable='false' data-prefix='fas' className='w-3 h-3 ml-auto' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'>
                        <path fill='currentColor' d='M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z' />
                      </svg>
                    </span>
                    <ul className='relative accordion-collapse collapse' id='collapseSidenavXxEx2' aria-labelledby='sidenavXxEx2' data-bs-parent='#sidenavSecExample'>
                      <li className='relative'>
                        <Link to='/reports' className='flex items-center text-xs py-4 pl-12 pr-6 h-6 overflow-hidden text-ellipsis whitespace-nowrap rounded hover:text-[#2b1e3e] hover:bg-blue-50 transition duration-300 ease-in-out' data-mdb-ripple='true' data-mdb-ripple-color='primary'>Reports</Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </>
      )}
    </main>
  );
};

export default SideBar;
